import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../../core';
import { DatepickerComponent } from '../../../../../shared';
import { CampanhaVigencia } from '../campanha-vigencia';

@Component({
    selector: 'sgt-campanha-vigencia-form',
    templateUrl: './campanha-vigencia-form.component.html',
    styleUrls: ['./campanha-vigencia-form.component.less']
})
export class CampanhaVigenciaFormComponent {
    /** Se a campanha é sob demanda */
    @Input() sobDemanda: boolean;
    @Input() entity: CampanhaVigencia;
    @Input() canEdit = true;
    @Input() canEditVigenciaRecorrente = true;
    @Input() canEditQuantidadeDiasVigencia = true;

    @ViewChild('form') form: NgForm;
    @ViewChild('quantidadeDiasVigenciaInput') quantidadeDiasVigenciaInput: ElementRef;
    @ViewChild('dataTerminoVigencia') dataTerminoVigencia: DatepickerComponent;

    constructor(private messageService: MessageService) { }

    /** Verifica se o form e suas informações está válidas */
    isValid(): boolean {
        // Se for uma campanha sob demanda então não tem o que validar na vigência
        if (this.sobDemanda) {
            return true;
        }

        // Não selecionada a vigência
        if (this.entity.vigenciaRecorrente == null || this.entity.vigenciaRecorrente === undefined) {
            this.messageService.warning(`É obrigatório selecionar se a vigência desta campanha é recorrente ou não. Selecione se é uma vigência recorrente ou não e tente novamente`, 'Atenção', notCloseMessageOptions);
            jQuery('#vigenciaRecorrenteSim').trigger('focus');
            return false;
        }

        // Se não for uma vigência recorrente é obrigatório ter informado a data inicial e final
        if (this.entity.vigenciaRecorrente === false) {
            // Quantidade de dias da vigência não informado
            if (this.canEditQuantidadeDiasVigencia && !this.entity.quantidadeDiasVigencia) {
                this.messageService.warning('É obrigatório informar a quantidade de dias quando a vigência não for recorrente. Informe a quantidade de dias e tente novamente', 'Atenção', notCloseMessageOptions);
                jQuery(this.quantidadeDiasVigenciaInput.nativeElement).trigger('focus');
                return false;
            }
        }

        // Form válido
        if (this.form.invalid) {
            this.messageService.warning('Informe corretamente todos os campos da vigência', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
